import { create } from "zustand";

interface AppState {
  activeTab: string;
  isDarkMode: boolean;
  setActiveTab: (tab: string) => void;
  toggleDarkMode: () => void;
  setDarkMode: (enabled: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  activeTab: "/",
  isDarkMode: true,

  setActiveTab: (tab) => set({ activeTab: tab }),

  toggleDarkMode: () =>
    set((state) => {
      const nextMode = !state.isDarkMode;
      applyDarkModeToDocument(nextMode);
      return { isDarkMode: nextMode };
    }),

  setDarkMode: (enabled) => {
    applyDarkModeToDocument(enabled);
    set({ isDarkMode: enabled });
  },
}));

function applyDarkModeToDocument(isDark: boolean): void {
  if (typeof document === "undefined") return;

  if (isDark) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}
